import { createContext, type ReactNode, useContext } from 'react';
import type { FtueHostAdapter } from './adapter';

const FtueHostContext = createContext<FtueHostAdapter | undefined>(undefined);

/**
 * Provides the host adapter to the shared FTUE flow. Each app wraps the FTUE in
 * this with its own adapter (add-in: Office/AuthContext; web: session-manager/upload).
 */
export function FtueHostProvider({
  adapter,
  children,
}: {
  adapter: FtueHostAdapter;
  children: ReactNode;
}) {
  return <FtueHostContext.Provider value={adapter}>{children}</FtueHostContext.Provider>;
}

/** Access the host adapter from any shared FTUE component. */
export function useFtueHost(): FtueHostAdapter {
  const adapter = useContext(FtueHostContext);
  if (!adapter) {
    throw new Error('useFtueHost must be used within a FtueHostProvider');
  }
  return adapter;
}
